module.exports = __webpack_public_path__ + "static/media/commande.343dd087.pdf";